<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-24 11:36:52
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterRecord\components\GenerateRoster.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-06 15:24:28
-->
<template>
  <normalDialog
    :dialog="show"
    width="680"
    :title="
      $t('label_essweb_rosterRecord_form_dialog_generateRosterRecordTitle')
    "
    maxWidth="680"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row dense>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_rosterRecord_form_dialog_rosterNameLabel")
            }}</v-sheet>
            <v-text-field
              dense
              filled
              :rules="$GetRules(['_Require_Rules'], [null])"
              maxlength="200"
              single-line
              :placeholder="
                $t('label_essweb_rosterRecord_form_dialog_rosterNameLabel')
              "
              v-model="rosterRecordData.roster_form_record_title"
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_rosterRecord_form_dialog_descriptionLabel")
            }}</v-sheet>
            <v-text-field
              dense
              filled
              maxlength="500"
              single-line
              :placeholder="
                $t('label_essweb_rosterRecord_form_dialog_descriptionLabel')
              "
              v-model="rosterRecordData.roster_form_record_description"
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_RosterRecord_dialog_dateLabel")
            }}</v-sheet>
            <DateTimePicker
              isRequire
              type="daterange"
              :value="curtime"
              :defaultStartTime="defaultStartDate"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :defaultEndTime="defaultEndDate"
              :placeholder="$t('label_essweb_RosterRecord_list_seTimeLabel')"
              @change="
                (time, isre) => {
                  curtime = time;
                  if (isre) {
                    defaultStartDate = time ? time.split(' - ')[0] : '';
                    defaultEndDate = time ? time.split(' - ')[1] : '';
                  }
                }
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              v-model="selectStaff"
              :items="curStaffs"
              chips
              label="label_essweb_RosterRecord_dialog_staffLabel"
              :filter="$staffFilter"
              deletable-chips
              multiple
              avatar
              two-line
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              item-text="staff_code"
              item-value="staff_id"
            >
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  size="36"
                  left
                  contentClass="white--text"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>

              <template v-slot:item.avatar="{ data }">
                <StaffAvatar
                  size="36"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:item.title="{ data }">
                <span class="text-body-2"
                  >{{ $getCommonLangValue(data.item.preferred_name) }}
                  <span class="text--secondary text-caption-xs">{{
                    data.item.staff_code
                  }}</span></span
                >
              </template>
              <template v-slot:item.subtitle="{ data }">
                {{ $getCommonLangValue(data.item.job_post_name) }}
              </template>
            </AutoComplete>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_rosterRecord_form_dialog_managersLabel"
              v-model="rosterRecordData.managerIds"
              :items="allStaff"
              chips
              :filter="$staffFilter"
              deletable-chips
              avatar
              two-line
              multiple
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              item-text="staff_code"
              item-value="staff_id"
            >
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  left
                  contentClass="white--text"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>

              <template v-slot:item.avatar="{ data }">
                <StaffAvatar
                  size="36"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:item.title="{ data }">
                <span class="text-body-2"
                  >{{ $getCommonLangValue(data.item.preferred_name) }}
                  <span class="text--secondary text-caption-xs">{{
                    data.item.staff_code
                  }}</span></span
                >
              </template>
              <template v-slot:item.subtitle="{ data }">
                {{ $getCommonLangValue(data.item.job_post_name) }}
              </template>
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              :items="allForm"
              isRequired
              label="label_essweb_rosterRecord_form_dialog_rosterFormLabel"
              item-text="roster_form_name"
              item-value="uuid"
              small-chips
              deletable-chips
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="rosterRecordData.roster_form_uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_rosterRecord_form_dialog_remarkLabel")
            }}</v-sheet>
            <v-text-field
              dense
              filled
              single-line
              maxlength="500"
              :placeholder="
                $t('label_essweb_rosterRecord_form_dialog_remarkLabel')
              "
              v-model="rosterRecordData.remarks"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions
        saveBtn
        @save="toSave"
        cancelBtn
        :onLoading="isLoading"
        saveText="label_essweb_rosterRecord_form_dialog_generateBtnLabel"
        @cancel="closeDialog"
      />
      <!-- 
         newBtn
        newText="label_essweb_form_tools_previousBtnLabel"
        @new="closeDialog"
       -->
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "GenerateRoster",
  computed: {
    ...mapGetters(["companyLang", "isLoading"]),
    allForm() {
      return this.$getSelectTrans(this.allFormData, "roster_form_name");
    },
    // allStaff() {
    //   let arr = [];
    //   const that = this;
    //   //2020-10-20 staff_id-->user_id//2021-11-20 user_id--staff_id
    //   this.curStaffs.map((item) => {
    //     if (that.selectStaffs.indexOf(Number(item["staff_id"])) != -1) {
    //       arr.push(item);
    //     }
    //   });
    //   return arr;
    // },
  },
  props: {
    show: { default: false, type: Boolean },
    // curStaffs: { default: [], type: Array },
    // selectStaffs: { default: [], type: Array },
  },
  watch: {
    show(val) {
      if (val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.curtime = "";
        this.selectStaff = [];
        this.defaultStartDate = "";
        this.defaultEndDate = "";
        this.rosterRecordData = {
          roster_form_uuid: "",
          roster_form_record_title: "",
          roster_form_record_description: "",
          remarks: "",
          startTime: "",
          endTime: "",
          managerIds: [],
          staffIds: [],
          remarks: "",
        };
      }
    },
  },
  data() {
    return {
      allFormData: [],
      curtime: "",
      allStaff: [],
      curStaffs: [],
      selectStaff: [],
      defaultStartDate: "",
      defaultEndDate: "",
      rosterRecordData: {
        roster_form_uuid: "",
        roster_form_record_title: "",
        roster_form_record_description: "",
        remarks: "",
        startTime: "",
        endTime: "",
        managerIds: [],
        staffIds: [],
        remarks: "",
      },
    };
  },
  mounted() {
    this.getRosterForm();
    this.getStaffs();
    this.$getStaffList().then((res) => {
      this.allStaff = res;
    });
  },
  methods: {
    removeStaff: function (item) {
      const index = this.rosterRecordData.managerIds.indexOf(item.staff_id);
      if (index >= 0) this.rosterRecordData.managerIds.splice(index, 1);
    },
    removeStaff2: function (item) {
      const index = this.selectStaff.indexOf(item.staff_id);
      if (index >= 0) this.selectStaff.splice(index, 1);
    },
    getRosterForm: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form",
        url: "/roster-form/get-list/",
      }).then((res) => {
        that.allFormData = res.data;
      });
    },
    getStaffs: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/get-staff-select/",
        data: { type: 2 },
      }).then((res) => {
        that.curStaffs = res.data;
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      if (this.rosterRecordData["managerIds"].length == 0) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_selectAgain"),
          text: this.$t(
            "label_essweb_rosterRecord_form_dialog_selectManagerLabel"
          ),
          type: "warning",
        });
        return false;
      }
      this.rosterRecordData["staffIds"] = this.selectStaff;
      this.rosterRecordData["start_time"] = this.defaultStartDate;
      this.rosterRecordData["end_time"] = this.defaultEndDate;
      this.$emit("onSave", this.rosterRecordData);
    },
  },
};
</script>
